import type { LifeItem } from '../models'
import { fromDateKey, getLunarDate, toDateKey } from './date'

export function occursOnDate(item: LifeItem, date: Date): boolean {
  const targetKey = toDateKey(date)
  if (targetKey < item.date) return false
  if (targetKey === item.date) return true

  const start = fromDateKey(item.date)
  switch (item.repeat) {
    case 'daily':
      return true
    case 'weekly':
      return start.getDay() === date.getDay()
    case 'monthly':
      return start.getDate() === date.getDate()
    case 'yearly-solar':
      return start.getMonth() === date.getMonth() && start.getDate() === date.getDate()
    case 'yearly-lunar': {
      const targetLunar = getLunarDate(date)
      const sourceLunar = item.lunarRepeat ?? getLunarDate(start)
      return Boolean(
        targetLunar &&
        sourceLunar &&
        targetLunar.month === sourceLunar.month &&
        targetLunar.day === sourceLunar.day &&
        targetLunar.intercalation === sourceLunar.intercalation,
      )
    }
    default:
      return false
  }
}

export function isCompletedOn(item: LifeItem, dateKey: string): boolean {
  return item.completedDates.includes(dateKey)
}
